<template>
  <div class="bg-white p-4 mx-8 rounded">
    <div class="flex bg-gray-200 rounded">
      <button
        @click.prevent="addGroup()"
        class="mx-auto p-4 text-primary text-lg transition-all duration-500 ease-in-out transform hover:scale-95 flex justify-center items-center"
      >
        <AddIcon class="w-6 fill-current text-primary" /> Add a Group
      </button>
    </div>
    <div v-if="groups.length > 0">
      <draggable
        v-model="groups"
        group="groups"
        @start="drag = true"
        @end="drag = false"
        handle=".move-group"
      >
        <div
          v-for="(group, index) in $v.groups.$each.$iter"
          :key="index"
          class="border-b mb-4"
        >
          <template v-if="!group.is_deleted.$model">
            <div class="sticky top-0 z-40 bg-white pt-4">
              <div class="grid grid-cols-4 mb-4">
                <div class="col-span-2">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    for="grid-group-name"
                  >
                    Group Name
                    <small
                      v-if="group.test_method_name.$model"
                      class="text-gray-500"
                      >from {{ group.test_method_name.$model }}</small
                    >
                  </label>
                  <div class="flex gap-2 items-center">
                    <div style="display: flex">
                      <!-- <div style="align-self: center; margin-right: .75rem; cursor: pointer;" @click="moveUp(index)" v-if="index != 0">
                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512"><path d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"/></svg>
                      </div>
                      <div style="align-self: center; margin-right: .75rem;cursor: pointer;" @click="moveDown(index)" v-if="index != groups.length - 1">
                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512"><path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg>
                      </div>
                      <div style="align-self: center; margin-right: 0rem; background-color: #17A1B7; border-radius: 20px; color: #fff; width: 30px; height: 30px; display: flex; justify-content: center; align-items: center;">
                        {{ parseInt(index) + 1 }}
                      </div> -->

                      <button class="rounded-sm border p-1 flex cursor-move move-group">
                        <svg
                          class="w-4 h-4 m-auto"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M4 6h16M4 10h16M4 14h16M4 18h16"
                          />
                        </svg>
                      </button>
                    </div>
                    <button
                      @click.prevent="toggleProductsList(index)"
                      class="rounded-sm border p-1 flex"
                    >
                      <svg
                        v-if="group.is_expanded.$model"
                        class="w-4 h-4 m-auto"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 15l7-7 7 7"
                        ></path>
                      </svg>
                      <svg
                        v-else
                        class="w-4 h-4 m-auto"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M19 9l-7 7-7-7"
                        ></path>
                      </svg>
                    </button>
                    <div class="flex flex-col">
                      <input
                        v-model="group.name.$model"
                        :class="{
                          'border-gray-200': group.name.required,
                          'border-red-500': !group.name.required,
                          'focus:border-gray-500': group.name.required,
                          'focus:border-red-500': !group.name.required
                        }"
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded p-2 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        placeholder="Group Name"
                      />
                      <p
                        v-if="!group.name.required"
                        class="text-red-500 text-xs italic"
                      >
                        Please fill out this field.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-span-2 flex justify-end items-center">
                  <button
                    @click="removeGroup(index)"
                    class="h-10 bg-gray-600 py-2 px-2 rounded transition-all duration-500 ease-in-out transform hover:scale-95"
                  >
                    <XIcon class="w-6 fill-current text-gray-300" />
                  </button>
                </div>
              </div>
              <div v-if="group.is_expanded.$model">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  for="grid-group-name"
                >
                  Products
                </label>
                <div
                  v-if="group.is_expanded.$model"
                  class="py-4 bg-gray-200 rounded"
                >
                  <ProductsAddNewProduct
                    :group-index="index"
                    v-on:select-product="addProduct"
                  />
                </div>
                <div>
                  <table class="table-fixed w-full">
                    <thead>
                      <tr>
                        <th class="w-1/12 border-b-2 border-gray-200 p-2" style="width: 100px">
                          <p class="text-center m-0 font-semibold text-sm">
                            Order
                          </p>
                        </th>
                        <th class="w-1/12 border-b-2 border-gray-200 p-2">
                          <p class="text-center m-0 font-semibold text-sm">
                            Add to Sum
                          </p>
                        </th>
                        <th class="w-1/12 border-b-2 border-gray-200 p-2">
                          <p class="text-left m-0 font-semibold text-sm">
                            Part Number
                          </p>
                        </th>
                        <th class="w-3/12 border-b-2 border-gray-200 p-2">
                          <p class="text-left m-0 font-semibold text-sm">
                            Product Name
                          </p>
                        </th>
                        <th class="w-1/12 border-b-2 border-gray-200 p-2">
                          <p class="text-right m-0 font-semibold text-sm">
                            Quantity
                          </p>
                        </th>
                        <th class="w-2/12 border-b-2 border-gray-200 p-2">
                          <p class="text-right m-0 font-semibold text-sm">
                            Unit Price
                          </p>
                        </th>
                        <th class="w-1/12 border-b-2 border-gray-200 p-2">
                          <p class="text-right m-0 font-semibold text-sm">
                            Discount (%)
                          </p>
                        </th>
                        <th class="w-2/12 border-b-2 border-gray-200 p-2">
                          <p class="text-right m-0 font-semibold text-sm">
                            Total
                          </p>
                        </th>
                        <th
                          class="w-1/12 border-b-2 border-gray-200 font-bold p-2"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            class="w-4 m-auto"
                          >
                            <path
                              class="primary"
                              d="M6.8 3.45c.87-.52 1.82-.92 2.83-1.17a2.5 2.5 0 0 0 4.74 0c1.01.25 1.96.65 2.82 1.17a2.5 2.5 0 0 0 3.36 3.36c.52.86.92 1.8 1.17 2.82a2.5 2.5 0 0 0 0 4.74c-.25 1.01-.65 1.96-1.17 2.82a2.5 2.5 0 0 0-3.36 3.36c-.86.52-1.8.92-2.82 1.17a2.5 2.5 0 0 0-4.74 0c-1.01-.25-1.96-.65-2.82-1.17a2.5 2.5 0 0 0-3.36-3.36 9.94 9.94 0 0 1-1.17-2.82 2.5 2.5 0 0 0 0-4.74c.25-1.01.65-1.96 1.17-2.82a2.5 2.5 0 0 0 3.36-3.36zM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
                            />
                            <circle cx="12" cy="12" r="2" class="secondary" />
                          </svg>
                        </th>
                      </tr>
                    </thead>
                      <!--
                      <tr>
                        <td colspan="8" class="py-4 bg-gray-200 rounded">
                          <ProductsAddNewProduct
                            :group-index="index"
                            v-on:select-product="addProduct"
                          />
                        </td>
                      </tr>
                      -->
                    <!-- <draggable
                      v-model="groups.items"
                      group="groups"
                      tag="tbody"
                      handle=".move-product"
                    > -->
                    <tbody>
                      <tr
                        v-for="(item, itemIndex) in group.items.$each.$iter"
                        :key="itemIndex"
                        :class="
                          parseFloat(item.unit_price.$model) === 0
                            ? 'bg-red-500'
                            : ''
                        "
                      >
                        <template v-if="!item.is_deleted.$model">
                          <td class="w-1/12 border-b-2 border-gray-200 p-2">
                            <div class="flex">
                              <div style="align-self: center; margin-right: .75rem; background-color: #E12C64; border-radius: 20px; color: #fff; width: 30px; height: 30px; display: flex; justify-content: center; align-items: center;">
                                {{ parseInt(itemIndex) + 1 }}
                              </div>
                              <div style="align-self: center; margin-right: .75rem;cursor: pointer; width:12px" @click="moveDownChild(index, itemIndex)" v-if="parseInt(itemIndex) != group.items.length - 1 && group.items.$each.$iter[parseInt(itemIndex) + 1] != undefined">
                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512"><path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg>
                              </div>
                              <div v-else style="width: 12px; margin-right: .75rem"></div>
                              <div style="align-self: center; margin-right: 0rem; cursor: pointer;" @click="moveUpChild(index, itemIndex)" v-if="parseInt(itemIndex) != 0">
                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512"><path d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"/></svg>
                              </div>
                              <!-- <button class="rounded-sm border p-1 flex cursor-move move-product">
                                <svg
                                  class="w-4 h-4 m-auto"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M4 6h16M4 10h16M4 14h16M4 18h16"
                                  />
                                </svg>
                              </button> -->
                            </div>
                          </td>
                          <td class="w-1/12 border-b-2 border-gray-200 p-2">
                            <div class="flex justify-center items-center">
                              <input
                                v-model="item.active.$model"
                                class="p-2"
                                type="checkbox"
                              />
                            </div>
                          </td>
                          <td class="w-1/12 border-b-2 border-gray-200 p-2">
                            <div class="flex justify-end items-center">
                              <div>
                                <input
                                  v-model="item.part_number.$model"
                                  :class="{
                                    'border-gray-200': item.part_number.required,
                                    'border-red-500': !item.part_number.required,
                                    'focus:border-gray-500':
                                      item.part_number.required,
                                    'focus:border-red-500': !item.part_number
                                      .required
                                  }"
                                  class="appearance-none block w-full bg-gray-200 text-gray-700 text-sm border rounded p-2 leading-tight focus:outline-none focus:bg-white"
                                  type="text"
                                  placeholder="Part Number"
                                />
                                <p
                                  v-if="!item.part_number.required"
                                  class="text-red-500 text-xs italic"
                                >
                                  Please complete
                                </p>
                              </div>
                            </div>
                          </td>
                          <td class="w-3/12 border-b-2 border-gray-200 p-2">
                            <div class="flex justify-start items-center">
                              <template>
                                <img
                                  v-if="item.product.image.$model"
                                  @click.prevent="
                                    expandImage(item.product.image.$model)
                                  "
                                  class="w-10 rounded shadow-lg hover:cursor-pointer"
                                  :src="item.product.image.$model"
                                  alt="Item Image"
                                />
                                <div
                                  v-else
                                  class="w-10 shadow-xs rounded bg-gray-300 py-2 px-1 break-words"
                                >
                                  <p
                                    class="text-xs text-center leading-none text-gray-700"
                                  >
                                    No image
                                  </p>
                                </div>
                              </template>
    
                              <div class="pl-2 w-full">
                                <div style="display: flex">
                                  <input
                                    v-model="item.name.$model"
                                    :class="{
                                      'border-gray-200': item.name.required,
                                      'border-red-500': !item.name.required,
                                      'focus:border-gray-500': item.name.required,
                                      'focus:border-red-500': !item.name.required
                                    }"
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 text-sm border rounded p-2 leading-tight focus:outline-none focus:bg-white"
                                    type="text"
                                    placeholder="Product Name"
                                  />
                                  <div class="tooltip-container" v-if="item.description.$model" style="margin-left: .5rem; align-self: center;">
                                    <button @mouseover="showTooltip = true" @mouseleave="showTooltip = false">
                                      <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>
                                    </button>
                                    <div v-if="showTooltip" class="tooltip">
                                      <pre v-html="item.description.$model"></pre>
                                    </div>
                                  </div>
                                </div>
                                <p
                                  v-if="!item.name.required"
                                  class="text-red-500 text-xs italic"
                                >
                                  Please complete
                                </p>
                              </div>
                            </div>
                          </td>
                          <td class="w-1/12 border-b-2 border-gray-200 p-2">
                            <div class="flex justify-end items-center">
                              <div>
                                <input
                                  v-model="item.quantity.$model"
                                  v-mask="'#####'"
                                  :class="{
                                    'border-gray-200': !item.quantity.$anyError,
                                    'border-red-500': item.quantity.$anyError,
                                    'focus:border-gray-500': !item.quantity
                                      .$anyError,
                                    'focus:border-red-500': item.quantity.$anyError
                                  }"
                                  class="appearance-none block w-16 bg-gray-200 text-right text-sm text-gray-700 border rounded p-2 leading-tight focus:outline-none focus:bg-white"
                                  type="number"
                                  placeholder="#"
                                />
                                <p
                                  v-if="!item.quantity.required"
                                  class="text-red-500 text-xs italic"
                                >
                                  Please complete
                                </p>
                                <p
                                  v-if="!item.quantity.minValue"
                                  class="text-red-500 text-xs italic"
                                >
                                  Please complete
                                </p>
                              </div>
                            </div>
                          </td>
                          <td class="w-2/12 border-b-2 border-gray-200 p-2">
                            <div class="flex justify-end items-center">
                              <div>
                                <money
                                  v-if="priceMarkUpOptionState"
                                  v-model="item.unit_price_calculated.$model"
                                  v-bind="money"
                                  :class="{
                                    'border-gray-200': !item.unit_price_calculated.$anyError,
                                    'border-red-500': item.unit_price_calculated.$anyError,
                                    'focus:border-gray-500': !item.unit_price_calculated
                                      .$anyError,
                                    'focus:border-red-500':
                                      item.unit_price_calculated.$anyError
                                  }"
                                  class="appearance-none block w-full text-right bg-gray-200 text-sm text-gray-700 border rounded p-2 leading-tight focus:outline-none focus:bg-white"
                                />
                                <money
                                  v-else
                                  v-model="item.unit_price.$model"
                                  v-bind="money"
                                  :class="{
                                    'border-gray-200': !item.unit_price.$anyError,
                                    'border-red-500': item.unit_price.$anyError,
                                    'focus:border-gray-500': !item.unit_price
                                      .$anyError,
                                    'focus:border-red-500':
                                      item.unit_price.$anyError
                                  }"
                                  class="appearance-none block w-full text-right bg-gray-200 text-sm text-gray-700 border rounded p-2 leading-tight focus:outline-none focus:bg-white"
                                />
                                <p
                                  v-if="!item.unit_price.required"
                                  class="text-red-500 text-xs italic"
                                >
                                  Please complete
                                </p>
                              </div>
                            </div>
                          </td>
                          <td class="w-1/12 border-b-2 border-gray-200 p-2">
                            <div class="flex justify-end items-center">
                              <div>
                                <!-- <input
                                  v-if="item.discount_is_custom.$model == 1"
                                  v-model="item.discount_forced.$model"
                                  v-mask="'##.##'"
                                  :class="{
                                    'border-gray-200': item.discount.required,
                                    'border-red-500': !item.discount.required,
                                    'focus:border-gray-500': item.discount.required,
                                    'focus:border-red-500': !item.discount.required
                                  }"
                                  class="appearance-none block w-full text-right text-sm bg-gray-200 text-gray-700 border rounded p-2 leading-tight focus:outline-none focus:bg-white"
                                /> -->
                                <!-- v-else -->
                                <input
                                  v-model="item.discount.$model"
                                  v-mask="'##.##'"
                                  :class="{
                                    'border-gray-200': item.discount.required,
                                    'border-red-500': !item.discount.required,
                                    'focus:border-gray-500': item.discount.required,
                                    'focus:border-red-500': !item.discount.required
                                  }"
                                  class="appearance-none block w-full text-right text-sm bg-gray-200 text-gray-700 border rounded p-2 leading-tight focus:outline-none focus:bg-white"
                                />
                                <p
                                  v-if="!item.discount.required"
                                  class="text-red-500 text-xs italic"
                                >
                                  Please complete
                                </p>
                              </div>
                            </div>
                          </td>
                          <td class="w-2/12 border-b-2 border-gray-200 p-2">
                            <money
                              v-if="priceMarkUpOptionState"
                              :value="
                                    (item.unit_price_calculated.$model * item.quantity.$model -
                                  (item.unit_price_calculated.$model *
                                    item.quantity.$model *
                                    item.discount.$model) /
                                    100)
                              "
                              v-bind="money"
                              class="appearance-none block w-full text-right text-gray-700 rounded p-2 leading-tight outline-none bg-white border-gray-500"
                              readonly
                            />
                            <money
                              v-else
                              :value="
                                  (item.unit_price.$model * item.quantity.$model -
                                  (item.unit_price.$model *
                                    item.quantity.$model *
                                    item.discount.$model) /
                                    100)
                              "
                              v-bind="money"
                              class="appearance-none block w-full text-right text-gray-700 rounded p-2 leading-tight outline-none bg-white border-gray-500"
                              readonly
                            />
                          </td>
                          <td
                            class="w-1/12 border-b-2 border-gray-200 text-center p-2"
                          >
                            <button
                              @click.prevent="removeProduct(index, itemIndex)"
                              class="h-8 bg-gray-600 py-2 px-2 rounded transition-all duration-500 ease-in-out transform hover:scale-95"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                class="w-4 fill-current text-gray-300"
                              >
                                <path
                                  class="primary"
                                  d="M5 5h14l-.89 15.12a2 2 0 0 1-2 1.88H7.9a2 2 0 0 1-2-1.88L5 5zm5 5a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1z"
                                />
                                <path
                                  class="secondary"
                                  d="M8.59 4l1.7-1.7A1 1 0 0 1 11 2h2a1 1 0 0 1 .7.3L15.42 4H19a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2h3.59z"
                                />
                              </svg>
                            </button>
                          </td>
                        </template>
                        <template v-else>
                          <td colspan="8" class="w-full"></td>
                        </template>
                      </tr>
                    <!-- </draggable> -->
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- <div v-if="group.is_expanded.$model">
              <table class="table-fixed w-full">
                
              </table>
            </div> -->
          </template>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { required, minLength, minValue } from "vuelidate/lib/validators";
import ProductsAddNewProduct from "~/components/app/ProductsAddNewProduct";
import { mapGetters } from "vuex";

let groupBy = function(xs, key) {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export default {
  name: "ProductsBody",

  props: {
    lineItems: {
      type: Array
    },
    priceMarkUpOption: {
      type: Number
    }
  },

  components: {
    draggable,
    ProductsAddNewProduct
  },

  data() {
    return {
      showTooltip: false,
      
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false
      },

      samples: {
        newItem: {
          active: true,
          image: null,
          part_number: null,
          name: null,
          description: null,
          unit_price: 0,
          quantity: 1,
          discount: 0,
          price_mark_up_option: 0,
          unit_price_calculated: 0
        }
      },

      groups: [],
      priceMarkUpOptionState: 0
    };
  },

  validations: {
    groups: {
      required,
      minLength: minLength(1),
      $each: {
        name: {
          required
        },
        is_deleted: {},
        test_method_name: {},
        is_expanded: {},
        items: {
          required,
          minLength: minLength(1),
          $each: {
            active: {},
            product: {
              image: {}
            },
            part_number: {
              required
            },
            name: {
              required
            },
            description: {
              required
            },
            quantity: {
              required,
              minValue: minValue(1)
            },
            unit_price: {
              required
              //minValue: minValue(0.01)
            },
            discount: {
              required
              //minValue: minValue(0.01)
            },
            is_deleted: {},
            price_mark_up_option: {},
            unit_price_calculated: {},
            discount_is_custom: {},
            discount_forced: {},
            discount_calculated: {},
          }
        }
      }
    }
  },

  mounted() {
    this.init();
    this.priceMarkUpOptionState = this.priceMarkUpOption / 100
  },

  watch: {
    groups: {
      async handler(val) {
        let lineItems = [];
        window._.forEach(val, group => {
          lineItems.push({
            id: group.id,
            test_method_group_id: group.test_method_group_id,
            name: group.name,
            label: group.name,
            items: group.items,
            is_deleted: group.is_deleted
          });
        });

        this.$emit("update-is-valid", this.isValidForm("groups"));
        this.$emit("update-line-items", lineItems);
      },
      deep: true
    },
    priceMarkUpOption: {
      handler(val) {
        this.groups = this.groups.map(group => {
          this.priceMarkUpOptionState = (isNaN(parseFloat(val)) ? 0 : parseFloat(val)) / 100
          group.items = group.items.map(item => {
            if (this.priceMarkUpOptionState) {
              item.unit_price_calculated = item.unit_price / (1 - this.priceMarkUpOptionState)
              if (parseFloat(item.unit_price_calculated) > parseInt(item.unit_price_calculated)) {
                item.unit_price_calculated = parseInt(item.unit_price_calculated) + 1
              }
            } else {
             item.unit_price_calculated = 0 
            }
            
            return item
          })

          return group
        })
        console.log('this.groups prickMarkUpOption', this.groups)
      }
    }
  },

  computed: {
    ...mapGetters({
      quoteId: "quoteForm/id",
      quoteRecord: "quoteForm/record"
    })
  },

  methods: {
    moveUp(index) {
      index = parseInt(index)
      if (index > 0) {
        const itemToMove = this.groups[index];
        this.groups.splice(index, 1);
        this.groups.splice(index - 1, 0, itemToMove);
      }
    },
    moveDown(index) {
      index = parseInt(index)
      if (index < this.groups.length - 1) {
        const itemToMove = this.groups[index];
        this.groups.splice(index, 1);
        this.groups.splice(index + 1, 0, itemToMove);
      }
    },
    moveUpChild(index, indexChild) {
      index = parseInt(index)
      indexChild = parseInt(indexChild)
      if (indexChild > 0) {
        const itemToMove = this.groups[index].items[indexChild];
        this.groups[index].items.splice(indexChild, 1);
        this.groups[index].items.splice(indexChild - 1, 0, itemToMove);
      }
    },
    moveDownChild(index, indexChild) {
      index = parseInt(index)
      indexChild = parseInt(indexChild)
      if (indexChild < this.groups[index].items.length - 1) {
        const itemToMove = this.groups[index].items[indexChild];
        this.groups[index].items.splice(indexChild, 1);
        this.groups[index].items.splice(indexChild + 1, 0, itemToMove);
      }
    },

    init() {
      if (this.lineItems.length > 0) {
        let groupsByTestMethodName = groupBy(
          this.lineItems,
          "test_method_name"
        );
        this.groups = [];
        Object.keys(groupsByTestMethodName).forEach(key => {
          this.groups = this.groups.concat(
            this.sortByName(groupsByTestMethodName[key])
          );
        });
        this.groups = _.sortBy(this.groups, ["order"]);
        //this.groups = this.sortByName(this.lineItems);
      }
    },

    validate() {
      return new Promise((resolve, reject) => {
        if (!this.isValidForm("groups")) {
          reject("Missing fields.");
          return;
        }
        resolve("All fields have been validated in Products Body.");
      });
    },

    sortByName(groups) {
      /*
      let first = ["main"];
      let last = ["spare"];
      groups.sort(function(x, y) {
        if (x.test_method_name) {
          first.push(x.test_method_name.toLowerCase());
        }
        let xName = x.name.toLowerCase().split(" ");
        let yName = y.name.toLowerCase().split(" ");
        return first.some(r => xName.includes(r))
          ? -1
          : first.some(r => yName.includes(r))
          ? 1
          : last.some(r => yName.includes(r))
          ? -1
          : 0;
      });
      */

      return groups;
    },

    addGroup() {
      this.groups.unshift({
        id: null,
        test_methods_group_id: null,
        name: "untitled",
        label: null,
        items: [],
        is_deleted: false,
        is_expanded: true
      });
    },

    removeGroup(index) {
      window.SwalWarning.fire({
        title: "Are you sure?",
        text: "This action cannot be undone",
        confirmButtonText: "Yes, remove it",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          this.groups[index].is_deleted = true;
          for (let i = 0; i < this.groups[index].items.length; i++) {
            this.groups[index].items[i].is_deleted = true;
          }
          window.SwalToast.fire({
            icon: "info",
            text: "The group has been removed."
          });
        }
      });
    },

    addProduct(groupIndex, product) {
      console.log('product', product)
      const priceStructure = this.quoteRecord.price_structure;
      console.log('priceStructure', priceStructure)
      
      let unitPrice = this.quoteRecord.type == "Domestic"
                  ? product.domestic_price
                  : product.international_price

      let discount = 0;

      if (priceStructure) {
        if (product.product_discount_options.length > 0) {
          const findProductDiscount = product.product_discount_options.find(
            productDiscount => productDiscount.discount_option_id == parseInt(priceStructure)
          );
          console.log('findProductDiscount', findProductDiscount)
          if (findProductDiscount) {
            discount = parseFloat(findProductDiscount.discount_value);
            console.log('discount', discount)
          }
        }
      }

      this.groups[groupIndex].items.push({
        /*
        key: Math.random()
          .toString(36)
          .substr(2, 9),
        */
        id: null,
        item_group_id: null,
        active: true,
        product_id: product.id,
        product: product,
        part_number: product.part_number,
        name: product.description,
        description: product.additional_description,
        unit_price: unitPrice,
        quantity: 1,
        discount: discount,
        quote_id: this.quoteId,
        is_deleted: false,
        unit_price_calculated: 0
      });
    },

    removeProduct(groupIndex, index) {
      window.SwalWarning.fire({
        title: "Are you sure?",
        text: "This action cannot be undone",
        confirmButtonText: "Yes, remove it",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          this.groups[groupIndex].items[index].is_deleted = true;
          window.SwalToast.fire({
            icon: "info",
            text: "The product has been removed."
          });
        }
      });
    },

    toggleProductsList(index) {
      const group = this.groups[index];
      group.is_expanded = !group.is_expanded;
    },

    expandImage(image) {
      window.Swal.fire({
        imageUrl: image,
        imageAlt: "Product Image",
        confirmButtonText: "Close"
      });
    }
  }
};
</script>

<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px;
  background: black;
  color: white;
  border-radius: 5px;
  z-index: 1;
  width: 400px;
}

.tooltip pre {
  white-space: pre-wrap; /* Respeta los espacios y saltos de línea */
  word-break: keep-all; /* Evita que las palabras se rompan al ajustar líneas */
  /* otros estilos que desees para tu tooltip */
}

/* Puedes agregar transiciones para efectos visuales */
.tooltip {
  transition: opacity 0.3s;
  visibility: hidden; /* por defecto oculto */
  opacity: 0;
}

/* Controlar la visibilidad con una clase en lugar de v-if podría ser más adecuado para transiciones */
.tooltip-container:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
</style>